// extracted by mini-css-extract-plugin
export var addressFields = "_kh-0";
export var animationContainer = "_kh-1";
export var footer = "_kh-2";
export var lineItems = "_kh-3";
export var modalContent = "_kh-4";
export var orderName = "_kh-5";
export var strong = "_kh-6";
export var warning = "_kh-7";